import styled, { css } from 'styled-components';

interface AccordionProps {
  menuOpen: boolean;
  type: 'menu' | 'default' | undefined;
}

export const AccordionStyle = styled.div<AccordionProps>`
  position: relative;
  .headerAccordion {
    display: flex;
    align-items: center;
    .contentHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      svg {
        transition: all 0.2s ease-in-out;
        transform: ${({ menuOpen }) => (menuOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
        fill: ${({ theme }) => theme.colors.background_white};
      }
      .contentTitle {
        display: flex;
        max-width: 30rem;
        align-items: center;
        gap: 0.5rem;
      }
    }

    .accordionTitle {
      border: none;
      background-color: transparent;
      font-size: 1.7rem;
      color: ${({ theme }) => theme.colors.secondary};
      font-family: 'Futura PT';
      font-weight: 600;
      padding: 0;
      cursor: pointer;
      text-align: left;

      p {
        font-size: 1.2rem;
        color: ${({ theme }) => theme.colors.background_white};
        font-family: 'Futura PT';
      }
    }

    p {
      color: ${({ theme }) => theme.colors.text_gray};
    }

    ${(props) =>
      props.type === 'default' &&
      css`
        @media (max-width: 615px) {
          flex-direction: column;
          align-items: start !important;
          gap: 0rem;
        }
      `};
  }

  .content {
    padding: 0 1rem;
    position: ${({ type }) => (type === 'menu' ? 'absolute' : '')};
    padding-top: ${({ type }) => (type === 'menu' ? '1.3rem' : '')};
    right: ${({ type }) => (type === 'menu' ? '-1rem' : '')};
  }

  @media (max-width: 700px) {
    .content {
      padding: ${({ type }) => (type === 'default' ? '0px !important' : '')};
    }
  }

  .headerAccordion {
    display: flex;

    .contentIcon {
      padding-left: 1rem;
      display: flex;
      align-items: center;

      svg {
        position: absolute;
        width: 1.1rem;
        height: 1.1rem;
        fill: ${({ theme }) => theme.colors.background_white};
        transition: all 0.2s ease -in -out;
        transform: ${({ menuOpen }) => (menuOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
      }
    }
  }
`;
